import { DatePipe, formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CodeListValues, AccrualAttachments, AccuralEmailPayload, ContractAccrualAttachments } from 'src/app/Finance/Models/contract-accrual';
import { FinanceService } from 'src/app/Finance/Services/invoice.service';
import { LoaderService } from 'src/app/Loader/loader.service';
import { SponserService } from 'src/app/MasterData/Services/sponser.service';

import { AuditIdentifier, AuditLogEntities, AuditLogModule, AuditOperations, ContractDraftInvoiceAuditFieldNames, ContractSubTabs, ContractTabs, Dateformat, FileExtension, SubTabNames, TabNames } from 'src/app/shared/constants/global.constants';
import { AuditLogService } from 'src/app/shared/ModelComparison/audit.log.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { FileUploadService } from 'src/app/Engagement/Services/fileupload.service';
import { NotificationService } from 'src/app/shared/Notifications/notification.service';
import { CurrencyService } from 'src/app/Reusable/currency.service';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';
import { } from 'console';
import { Datetime } from 'aws-sdk/clients/costoptimizationhub';
import { environment } from 'src/environments/environment';
import { encryptUrlParams } from 'src/app/shared/Urlencoder/url-encoder.util';

@Component({
  selector: 'app-con-accruals-edit',
  templateUrl: './con-accruals-edit.component.html',
  styleUrls: ['./con-accruals-edit.component.css']
})

export class ConAccrualsEditComponent {
  
  @Output() cancelAccrualButtonClick = new EventEmitter<void>();
  @Output() saveAccrualButtonClick = new EventEmitter<void>();
  @Output() viewButtonClick: EventEmitter<any> = new EventEmitter<any>();


  accrualStatusDataSource: CodeListValues[] | undefined;
  accrualForm: FormGroup;
  @Input() contractId: any;
  @Input() contractName: any;
  @Input() accrualId: any;
  @Input() SupplierId: any;
  @Input() SponsorId: any;
  @Input() EngagementName: any;
  @Input() Currency: any;

  accrualDetail:any;
  accrualDetailOld:any;
  accrualSubmitted:boolean=false;
  isSaveBtnDisable = false;
  _dateformart :any;
  _accuralEmailPayload=new AccuralEmailPayload();
  currency:any;
  currentIndex: number = -1; 
  listOfDraftInvocies:any;
  constructor(private route: ActivatedRoute,private router:Router,private loaderService: LoaderService,
    private confirmationService: ConfirmationService,private messageService: MessageService,
    private _fileService: FileUploadService,private datePipe: DatePipe,private formBuilder: FormBuilder,
    private financeService:FinanceService, private masterDataService: SponserService,
    private auditLogService: AuditLogService,private privilegeService: PrivilegeService,
    private notificationService:NotificationService,private currencyService: CurrencyService, private tabAndStateService: TabAndStateService ){
  
     this.accrualForm = this.formBuilder.group({
      _accrualAmount: ['', [Validators.required,Validators.pattern(/^\d{1,13}\.\d{1,2}$|^\d{1,15}$/)]],
      _statusMappingId: ['', [Validators.required]],
      _remarks:['', [Validators.maxLength(300)]],
      _accrualFile: [''], 
      _accrualFileName: '',
      _accrualAttachments: [''],
    });
  
  }

  attchement:any
  accrualAttachment:any;
  accrualAttachments: AccrualAttachments[]=[];
  auditIdentifierDetails:any;
  auditEntities:any;
 auditOperations:any;
auditModule:any;
updatedBy:any;
oldStatus:any;
oldAmout:any;

   ngOnInit() {
    this.bindData(this.accrualId);
    this.GetAccrualStatus(3);
    this._dateformart=Dateformat;
    this.auditEntities=AuditLogEntities;
    this.auditOperations=AuditOperations;
    this.auditModule=AuditLogModule;
    this.currency= this.route.snapshot.queryParamMap.get('currency');
       if(!this.currency){
      this.currency= this.route.snapshot.paramMap.get('currency')
    }
  this.listOfDraftInvocies=this.tabAndStateService.getDraftInvoicesData();
  this.currentIndex = this.listOfDraftInvocies.findIndex((a: { accrualDate: any; }) => a.accrualDate ==this.accrualDetail.accrualDate);
}
  
approvedByUser:any;
bindData(data:any)
{
  this.accrualDetail = data;
   if(data.financeContractAccrualAttachments && data.financeContractAccrualAttachments.length>0){

            this._contractAccrualAttachments.Id = data.financeContractAccrualAttachments[0].id;
            this._contractAccrualAttachmentsDetails= data.financeContractAccrualAttachments;
            this.uploadedFiles = data.financeContractAccrualAttachments.map((attachment: { fileName: any; }) => {
              return new File([attachment.fileName], attachment.fileName);
            });
  
          this.uploadedFileNames = this.uploadedFiles.map(file => file.name).join(', ');
            if(this.uploadedFiles.length >= 3)
            {
              this.isUploadButtonDisabled = true;
            }
            else{
              this.isUploadButtonDisabled = false;
            }
          }

 
  if(this.accrualDetail.id!=0)
    {
      if(this.accrualDetail.statusMappingId==0) //this.accrualDetail.accrualAmount==0 
      {
        this.accrualDetail.accrualAmount=null;
        this.accrualDetail.statusMappingId=null;
      }
      
      this.accrualDetail.contractDetailId=this.contractId;
      this.updatedBy=this.privilegeService.getUserName(this.accrualDetail.updatedBy); 
      if(this.accrualDetail.approvedBy!=null){
      this.approvedByUser= this.privilegeService.getUserName(this.accrualDetail.approvedBy);
      }
      else{
        this.approvedByUser=null;
      }

     this.oldAmout=this.accrualDetail.accrualAmount;
     this.oldStatus=this.accrualDetail.statusMappingId;
    }
    else{
      this.approvedByUser=null;
      this.updatedBy=null;
      this.accrualDetail.accrualAmount=null;
      this.accrualDetail.remarks=null;
      this.accrualDetail.statusMappingId=null;
      if(this.accrualDetail.statusMappingId==0){
        this.accrualDetail.statusMappingId=null;
        
      }
      
      this.accrualDetail.contractDetailId=this.contractId;
    }

    this.GetAccrualStatus(3);
   
   
   this.accrualDetailOld=JSON.stringify(this.accrualDetail);
   this.auditIdentifierDetails=AuditIdentifier; 

   this.oldContractAccuralData=JSON.stringify(this.accrualDetail);
  this.contractAccuralDetailBeforeUpdate=JSON.stringify(this.accrualDetail);
}  
validateNumericField(control: any) {
  const numericRegex = /^\d+(\.\d{1,2})?$/;
  if (control.value && !numericRegex.test(control.value)) {
    return { invalidNumber: true };
  }
  return null;
}

isDisabled=false;
GetAccrualStatus(type:number) {
      this.masterDataService.getCodeListData(type,'Accrual Status').subscribe(
        res=>{
          this.accrualStatusDataSource=res.data;
          var status= this.accrualStatusDataSource?.find(data=>data.id==this.accrualDetail.statusMappingId)?.name;
          if(status=='Approved'){
              this.isDisabled=true;
          }
          else{
              this.isDisabled=false;
          }
        }
      );
};
   
GetContractAccrualDetailById() {
      if(this.accrualDetail.id>0){
        this.financeService.GetContractAccrualDetailById(this.accrualDetail.id).subscribe(
          res=>{
            let accrualData=res.data;
          }
        );
      }
};


onCancelContractAccrual()
{
 if((this.accrualDetailOld==JSON.stringify(this.accrualDetail)))
 {
  this.cancelAccrualButtonClick.emit();
 }
 else{
  this.confirmationService.confirm({
    header: 'Confirm',
    message: 'Changes will not be saved, Do you want to Continue?',
    accept: () => {
    this.messageService.add({key: 'tc', severity: 'warn', summary: 'Changes not saved', detail: ''});
    this.cancelAccrualButtonClick.emit();
  }
  });
 }
}

async saveContractAccrual()
{
  this.accrualSubmitted=true;
  this.isSaveBtnDisable = true;
  setTimeout(() => {
    this.isSaveBtnDisable = false;
  }, 3000);
  if(this.accrualForm.valid)
  {
    this.loaderService.showLoader();
       if (this.deleteUploadedFiles.length > 0 ) {
        this.deleteAccrualsAttachment();
      }
      
    if (this.multiAccrualFileData.length > 0) {
      this._fileService.UploadMultipleFile(this.formData).subscribe((response: any) => {
        if (response) {
         this.updateAccrualDetails();
        }
        else {
          this.loaderService.hideLoader();
          this.messageService.add({ key: 'tc', severity: 'warn', summary: 'Add Accrual File Failed to save', detail: '' });
        }
      })
    }
    else {
      this.updateAccrualDetails();
    }
  }
  else{
    this.messageService.add({  key: 'tc',severity: 'warn', summary: 'Please enter required information', detail: '' });  
  }
}
isStatusApproved:boolean=false;
isDataUpdate:boolean=false;
_TabId:any;
_SubTabId:any;
updateAccrualDetails(){
        this.accrualDetail.accrualDate = this.datePipe.transform(this.accrualDetail.accrualDate, "MM/dd/yyyy");
        this.accrualDetail.createdBy = this.privilegeService.getLoginUserId();
        this.accrualDetail.updatedBy = this.privilegeService.getLoginUserId();
   this.accrualDetail.financeContractAccrualAttachments = this._contractAccrualAttachmentsDetails;
        this.accrualDetail.accrualStatus = this.accrualStatusDataSource?.find(data=>data.id==this.accrualDetail.statusMappingId)?.name;
  
        if(this.oldAmout!=this.accrualDetail.accrualAmount)
          {
            this.isDataUpdate=true;
          }
          if(this.oldStatus!=this.accrualDetail.statusMappingId && this.accrualDetail.accrualStatus=="Approved")
          {
              this.isStatusApproved=true;
          }


  this.financeService.UpdateContractAccrual(this.accrualDetail).subscribe(async res => {
    if(res.status)
    {
     
      this._accuralEmailPayload.SupplierId=this.SupplierId;
      this._accuralEmailPayload.ContractId=this.contractId;
      this._accuralEmailPayload.SponsorId=this.SponsorId;
      this._accuralEmailPayload.EngagementName=this.EngagementName;
      const formattedValue = this.getFormattedValue(parseFloat(this.accrualDetail.accrualAmount), this.currency);
      this._accuralEmailPayload.AccrualAmount = formattedValue;
      this._accuralEmailPayload.AcrualMonthYear= this.datePipe.transform(this.accrualDetail.accrualDate, "MMMM yyyy");
      this._accuralEmailPayload.Currency=this.currency;
      this.messageService.add({ key: 'tc', severity: 'success', summary: 'Changes have been saved', detail: '' });
      if(this.isDataUpdate && !this.isStatusApproved)
        {
           // Mail Notification 
                       
                          const contractTabName = TabNames.FINANCE;
                          const contractSubTabName = SubTabNames.FINANCE.DRAFT_INVOICE;
          
                          const contractTab = ContractTabs.find(t => t.name == contractTabName);
                          this._TabId = contractTab?.id ?? null;
          
                          const contractSubTab = ContractSubTabs[contractTabName]?.find(st => st.name == contractSubTabName);
                          this._SubTabId = contractSubTab?.id ?? null;
          
                          const payload = {
                          ContractId: this.contractId,
                          currency: this.currency,
                          TabId: this._TabId,
                           SubTabId: this._SubTabId
                            };
                          const encoded = encryptUrlParams(payload);

                          const baseUrl= environment?._kontractProUrl;
                          const contractUrl = `${baseUrl}/viewcontract?d=${encoded}`;
                           this._accuralEmailPayload.contractLinkHtml = `<a href="${contractUrl}">Link</a>`;
                         //End Mail Notification  
           await this.notificationService.UpdateAccuralNotification(this._accuralEmailPayload,1);
        }
        if(this.isStatusApproved)
          {
            this._accuralEmailPayload.ApprovedByUser=this.privilegeService.getUserName(this.accrualDetail.approvedBy);
            this._accuralEmailPayload.ApprovedDateTime=this.accrualDetail.approvedDateTime;
            this._accuralEmailPayload.ApprovedDateTime=new Date(this._accuralEmailPayload.ApprovedDateTime.getTime() - (5.5 * 60 * 60 * 1000)); // Convert to UTC
            
             // Mail Notification 
                       
                          const contractTabName = TabNames.FINANCE;
                          const contractSubTabName = SubTabNames.FINANCE.DRAFT_INVOICE;
          
                          const contractTab = ContractTabs.find(t => t.name == contractTabName);
                          this._TabId = contractTab?.id ?? null;
          
                          const contractSubTab = ContractSubTabs[contractTabName]?.find(st => st.name == contractSubTabName);
                          this._SubTabId = contractSubTab?.id ?? null;

                         const payload = {
                          ContractId: this.contractId,
                          currency: this.currency,
                          TabId: this._TabId,
                           SubTabId: this._SubTabId
                            };
                          const encoded = encryptUrlParams(payload);
                          const baseUrl= environment?._kontractProUrl;
                          
                          const contractUrl = `${baseUrl}/viewcontract?d=${encoded}`;

                           this._accuralEmailPayload.contractLinkHtml = `<a href="${contractUrl}">Link</a>`;
                         //End Mail Notification  

            await this.notificationService.UpdateAccuralNotification(this._accuralEmailPayload,2);
          }
      this.compareModels();
      this.loaderService.hideLoader();
      this.saveAccrualButtonClick.emit();
    }
    else{
       if (res.message == 'This record is being updated by another user. Please refresh the page.')
       {
      this.messageService.add({
        key: 'tc',
        severity: 'warn',
        summary: res.message,
        detail: ''
      });
    }
      this.loaderService.hideLoader();
    }
  });
 
}

maxFileSize:any;
uploadedAccrualFileData: any[] = [];
timeStamp:any;
accrualFormData = new FormData();

 currentFileSize: any;
   uploadedFileName: any;
  allowedExtensions: any;
    uploadedAccrualFile: any;
      newAttachment: any;


deleteAccuralFile() : any {
  let isDeleted=false;
   this._fileService.DeleteFile(this.deleteAccuralFiles).subscribe(responseDelete=>{
       return isDeleted =responseDelete;
       } 
   );
 }



 deleteAccuralFiles : any[]=[]; 

fileDetail:any;

private handleDownloadError() {
  this.loaderService.hideLoader();
  this.messageService.add({
      key: 'tc',
      severity: 'warn',
      summary: 'Sorry, unable to download the file',
      detail: ''
  });
}


prepareDownload(filename:any, file:any) {

  

  let fileContent= file;
  const fileData=new Blob([fileContent], { type:"text/plain"});
  const link = document.createElement('a');
  link.href = URL.createObjectURL(fileData);
  link.download=filename;
  link.click();
  link.remove();

  this.loaderService.hideLoader();
}

changedContractAccuralBasicInfo:any;
oldContractAccuralData:any;
contractAccuralDetailBeforeUpdate:any
compareModels() {
  this.changedContractAccuralBasicInfo = this.auditLogService.compareModels(
    JSON.parse(this.contractAccuralDetailBeforeUpdate),
    this.accrualDetail,
    this.auditEntities.ContractAccruals,
    this.auditIdentifierDetails.ContractAccruals,
    this.auditOperations.Update,
    this.auditModule.FinanceService,
    {
      'Contract': this.contractName,
      'Draft Invoice Date': this.accrualDetail?.accrualDate
    },
    ContractDraftInvoiceAuditFieldNames);
}
getFormattedValue(value: number, currencyName: string): string {
  return this.currencyService.getFormattedValue(value, currencyName);
}
navigateTo(index: number): void {
  if (index >= 0 && index < this.listOfDraftInvocies.length) {
      this.accrualDetail=this.listOfDraftInvocies[index];
      this.bindData(this.accrualDetail);
      this.currentIndex=index;
  }
}
nextRecord(): void {
  this.navigateTo(this.currentIndex + 1);
}
previousRecord(): void {
  this.navigateTo(this.currentIndex - 1);
}
getCurrentPositionText(): string {
  return `${this.currentIndex + 1} of ${this.listOfDraftInvocies.length}`;
}
pageChangeConfirmation(buttonType:number):void{
  if((this.accrualDetailOld==JSON.stringify(this.accrualDetail)))
  {
    buttonType==1?this.nextRecord():this.previousRecord();
  }
  else{
    this.confirmationService.confirm({
      message: 'Changes will not be saved, Do you want to Continue?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.messageService.add({
          key: 'tc',
          severity: 'info',
          summary: 'Changes not saved',
          detail: '',
      });
       buttonType==1?this.nextRecord():this.previousRecord();
      },
      reject: () => {
    
      },
    });
  }
}

onStatusChange(event:any){
 var status= this.accrualStatusDataSource?.find(data=>data.id==event.value)?.name;

if(status=='Approved')
{
  this.accrualDetail.approvedBy=this.privilegeService.getLoginUserId();;
  this.accrualDetail.approvedDateTime=new Date();
 }
else{
  this.accrualDetail.approvedBy=null;
  this.accrualDetail.approvedDateTime=null;
}

}
  uploadedFiles: File[] = [];
  _contractAccrualAttachmentsDetails: any[] = [];
  uploadedFileNames: string = "";
  isUploadButtonDisabled: boolean = false;
  _contractAccrualAttachments = new ContractAccrualAttachments();
  multiAccrualFileData: any[] = [];
  formData = new FormData();

  onFileChange(event: any) {
    const files: FileList = event.target.files;
    if (files.length <= 1) {
      this.maxFileSize = this._fileService._fileSize; // 20 MB (value Bytes in binary)
      if (files.length > 0) {
        this.currentFileSize = files[0].size;
        this.uploadedFileName = files[0].name;
        this.allowedExtensions = [FileExtension.DOC, FileExtension.DOCX, FileExtension.PDF, FileExtension.XLS, FileExtension.XLSX, FileExtension.PPT, FileExtension.PPTX];
        var uploadedExtension = this.uploadedFileName.split('.').pop().trim().toLowerCase();
      }
      if (this.allowedExtensions.includes(uploadedExtension)) {
        if (this.currentFileSize <= this.maxFileSize) {
          if (this.uploadedFiles.length + files.length <= 3) {
            for (let i = 0; i < files.length; i++) {
              this.uploadedFiles.push(files[i]);
              this.accrualForm.patchValue({
                _accrualAttachments: files[0].name,
              });
              this.uploadedAccrualFile = files[0];
              this.multiAccrualFileData.push(this.uploadedAccrualFile);
              this.timeStamp = "";
              var utcDateTimeNow = new Date().toISOString();
              this.timeStamp = formatDate(utcDateTimeNow, this._dateformart.FiletimeStamp, this._dateformart.TimeStampZone);
              this.formData.append("file", this.uploadedAccrualFile, "/Contracts/Finance/Accrual/" + this.timeStamp + "_" + this.uploadedAccrualFile.name);
              this._contractAccrualAttachments.FileName = this.uploadedAccrualFile.name;
              this._contractAccrualAttachments.FilePath = "/Contracts/Finance/Accrual/" + this.timeStamp + "_" + this._contractAccrualAttachments.FileName;

              this.newAttachment = {
                FileName: this._contractAccrualAttachments.FileName,
                FilePath: this._contractAccrualAttachments.FilePath
              };
              this._contractAccrualAttachmentsDetails.push(this.newAttachment);
            }
          } else {
            this.accrualForm.patchValue({
              _accrualFileName: '',
              _accrualFile: ''
            });

            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Maximum 3 files allowed.', detail: '' });
          }
        }
        else {
          this.accrualForm.patchValue({
            _accrualFileName: '',
            _accrualFile: ''
          });
          this.messageService.add({ key: 'tc', severity: 'warn', summary: 'File Size limited to 20 Mb', detail: '' });
        }
      }
      else {
        this.accrualForm.patchValue({
          _accrualFileName: '',
          _accrualFile: ''
        });
        this.messageService.add({ key: 'tc', severity: 'error', summary: 'Invalid file type. Only .pdf, .xls, .xlsx, .doc, .docx files are allowed.', detail: '' });
      }

    }
    else {
      this.accrualForm.patchValue({
        _accrualFileName: '',
        _accrualFile: ''
      });
      this.messageService.add({ key: 'tc', severity: 'error', summary: 'Select and upload 1 file at a time.', detail: '' });

    }
    if (this.uploadedFiles.length >= 3) {
      this.isUploadButtonDisabled = true;
    }
    else {
      this.isUploadButtonDisabled = false;
    }
  }
downloadAttachment(data:any)
{
  var attachment = this._contractAccrualAttachmentsDetails.find(attachment => attachment.fileName === data.name);

  if (attachment !== null) {
    this.downloadFile(attachment?.fileName, attachment?.filePath);
  }

}

async downloadFile(fileName:any,filePath:any){
  this.auditLogService.logDownloadWithFilters('Draft Invoice Attachment',AuditIdentifier.ContractAccruals,AuditLogModule.FinanceService,fileName,{
    'Contract': this.contractName,
    'Draft Invoice Date': this.accrualDetail?.accrualDate
  });


var fileDetail = {
  "fileName":fileName,
  "filePath":filePath
};
this._fileService.DownloadFile(fileDetail).subscribe(
  async (res:any)=>{
      var blobData = this._fileService.dataURItoBlob(res);
      if(blobData.size>0){
         var response = await this._fileService.downloadBase64File(blobData,fileDetail.fileName);
         this.loaderService.hideLoader();
      }
      else{
        this.loaderService.hideLoader();
        
      }
  } 
);
}

  deleteUploadedFiles: any[] = [];
  removeFile(file: File) {
    const index = this.uploadedFiles.indexOf(file);
    if (index !== -1) {
      this.uploadedFiles.splice(index, 1);

      const attachmentIndex = this._contractAccrualAttachmentsDetails.findIndex(attachment => attachment.FileName === file.name);
      if (attachmentIndex !== -1) {
        this._contractAccrualAttachmentsDetails.splice(attachmentIndex, 1);
      }
      this._contractAccrualAttachmentsDetails = this._contractAccrualAttachmentsDetails.map(e => {
        return this.convertKeysToUppercase(e);
    });
    var isOldAccrualAttachement = this._contractAccrualAttachmentsDetails.some(item => item.hasOwnProperty('Id'));
    if(isOldAccrualAttachement){
      const editAccrualAttachment= this._contractAccrualAttachmentsDetails.findIndex(s => s.FileName == file.name && s.Id != 0);
      if (editAccrualAttachment !== -1) {    
        var filedetails = {
          "fileName":  this._contractAccrualAttachmentsDetails[editAccrualAttachment].FileName,
          "filePath":  this._contractAccrualAttachmentsDetails[editAccrualAttachment].FilePath
        };
        if (filedetails.fileName != "" && filedetails.filePath != "") {                    
              this.deleteUploadedFiles.push(filedetails);    
              this._contractAccrualAttachmentsDetails.splice(editAccrualAttachment,1)                          
          }
      }   
    }
    else{
      if(this._contractAccrualAttachmentsDetails)
      {
        const index = this._contractAccrualAttachmentsDetails.findIndex(attachment => attachment.FileName === file.name);
        if (index !== -1) {      
          this._contractAccrualAttachmentsDetails.splice(index,1)
      }     
      }
    }

    }
    if(this.uploadedFiles.length >= 3)
    {
      this.isUploadButtonDisabled = true;
    }
    else{
      this.isUploadButtonDisabled = false;
    }
  }
  convertKeysToUppercase(obj: any): any {
    const convertedObject: any = {};
  
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const uppercaseKey = key.charAt(0).toUpperCase() + key.slice(1);
            convertedObject[uppercaseKey] = obj[key];
        }
    }
  
    return convertedObject;
  }

    deleteAccrualsAttachment(){
    this._fileService.DeleteFile(this.deleteUploadedFiles).subscribe(
      res => {
    
        
      }
    );
    }

}


